export default __webpack_public_path__ + "static/media/two.d07c6cb7.jpg";